import { render, staticRenderFns } from "./community_list.vue?vue&type=template&id=5520cd00&scoped=true&"
import script from "./community_list.vue?vue&type=script&lang=js&"
export * from "./community_list.vue?vue&type=script&lang=js&"
import style0 from "./community_list.vue?vue&type=style&index=0&id=5520cd00&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5520cd00",
  null
  
)

export default component.exports